// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    padding-top: 20px;
    align-items: center;
    list-style: none;
}   
 a {
    text-decoration: none;
}

.closeIcon {
    font-size: 1.5rem;
}
.home-menu-item {
    justify-self: flex-start;
    width: 80px;
    margin-top: -10px;
}

.menu-item {
    justify-self: end;
    font-size: 14px;
    align-self: end;
    margin-right: 90px;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    font-weight: 700;
   
    & a {
        color: #8e8e8e;
    }
}

.menu-container {
    display: flex;
    align-items: end;
}

.contact {
    margin-right: 0;
}

label, #toggle
{
    display: none;
}

.menu-mobile {
    display: none;
    flex-direction: column;
    background: #F8F2F2;
    position: absolute;
    width: 100%;
    height: calc(100vh - 96px);
    justify-content: start;
    padding-top: 32px;
    left: 0;

    & .menu-item {
        margin-right: 24px;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 600;
    }
}

a:visited {
    color:  #8e8e8e;
}

a:active {
    color:  #8e8e8e;
  }

@media all and (max-width: 991px)
{
    nav
    {
        height: 60px;
    }
 
    nav .menu-container
    {
        display: none;
    }

    nav  .menu-mobile {
        display: none;
    }
    

    nav .menu-item
    {
        justify-content: center;
        align-items: center;
    }
 
    label 
    {
        width: 30px;
        display: flex;
        justify-content: end;
        align-items: center;
        margin: 0 1rem;
        font-size: 40px;
        color: black;
        cursor: pointer;
    }

    #toggle:checked + .menu-mobile {
        display: flex;
        align-items: center;
        position: absolute;
        width: 100%;
        z-index: 9999;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Menu.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;CACC;IACG,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;;IAEhB;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;IACjB,OAAO;;IAEP;QACI,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;EACjB;;AAEF;;IAEI;;QAEI,YAAY;IAChB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;;IAGA;;QAEI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;QACX,aAAa;QACb,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":[".menu-list {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 0;\n    padding-top: 20px;\n    align-items: center;\n    list-style: none;\n}   \n a {\n    text-decoration: none;\n}\n\n.closeIcon {\n    font-size: 1.5rem;\n}\n.home-menu-item {\n    justify-self: flex-start;\n    width: 80px;\n    margin-top: -10px;\n}\n\n.menu-item {\n    justify-self: end;\n    font-size: 14px;\n    align-self: end;\n    margin-right: 90px;\n    letter-spacing: 0.1rem;\n    text-transform: uppercase;\n    font-weight: 700;\n   \n    & a {\n        color: #8e8e8e;\n    }\n}\n\n.menu-container {\n    display: flex;\n    align-items: end;\n}\n\n.contact {\n    margin-right: 0;\n}\n\nlabel, #toggle\n{\n    display: none;\n}\n\n.menu-mobile {\n    display: none;\n    flex-direction: column;\n    background: #F8F2F2;\n    position: absolute;\n    width: 100%;\n    height: calc(100vh - 96px);\n    justify-content: start;\n    padding-top: 32px;\n    left: 0;\n\n    & .menu-item {\n        margin-right: 24px;\n        margin-bottom: 20px;\n        font-size: 20px;\n        font-weight: 600;\n    }\n}\n\na:visited {\n    color:  #8e8e8e;\n}\n\na:active {\n    color:  #8e8e8e;\n  }\n\n@media all and (max-width: 991px)\n{\n    nav\n    {\n        height: 60px;\n    }\n \n    nav .menu-container\n    {\n        display: none;\n    }\n\n    nav  .menu-mobile {\n        display: none;\n    }\n    \n\n    nav .menu-item\n    {\n        justify-content: center;\n        align-items: center;\n    }\n \n    label \n    {\n        width: 30px;\n        display: flex;\n        justify-content: end;\n        align-items: center;\n        margin: 0 1rem;\n        font-size: 40px;\n        color: black;\n        cursor: pointer;\n    }\n\n    #toggle:checked + .menu-mobile {\n        display: flex;\n        align-items: center;\n        position: absolute;\n        width: 100%;\n        z-index: 9999;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
